<template>
  <div>
    <multiselect
      v-model="selected"
      :options="options"
      placeholder="Type to search"
      track-by="ID"
      label="address"
      :max-height="125"
      :allow-empty="allowEmpty"
      :multiple="isMultiple"
      :searchable="true"
      @search-change="handleSearch"
      :internal-search="false"
      :disabled="isDisabledV2"
    >
      <span slot="noResult">Oops! No data found</span>
      <template slot="singleLabel" slot-scope="props">
        <span class="option__desc">
          <span class="option__title"
            >{{ props.option.code }} - {{ props.option.contact_name }} - {{ props.option.address }}</span
          >
        </span>
      </template>

      <template slot="option" slot-scope="props">
        <div class="option__desc">
          <span class="option__title"
            >{{ props.option.code }} - {{ props.option.contact_name }} - {{ props.option.address }}</span
          >
        </div>
      </template>
    </multiselect>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/repositoryFactory";
import _ from "lodash";
const MasterRepository = RepositoryFactory.get("master");
export default {
  props: {
    isGetData: {
      type: Boolean,
      default: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    allowEmpty: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    formDatas: null,
  },
  data() {
    return {
      result: [],
      options: [],
      selected: null,
      isDisabledV2:false,
    };
  },
  mounted() {
    this.isDisabledV2 = this.isDisabled
    if (this.isGetData) {
      this.getDataShipTo();
    }
  },
  methods: {
    setDisabled(isDisabled) {
      this.isDisabledV2 = isDisabled;
      // this.isDisabled = isDisabled;
    },
    handleSearch: _.debounce(function (query) {
      if (query.length >= 2) {
        let params_ = { search: query, is_default: false, };
        if (this.formDatas != null){
          if (this.formDatas.territory_id != 0) {
            params_ = { search: query, territory_id: this.formDatas.territory_id, so_type:this.formDatas.so_types, is_default: false, is_create: (this.formDatas.isDetail != 1 && !this.formDatas.isEdit) };
          }
          if(this.formDatas.customer_data.customer_id){
            params_ = { search: query, territory_id: this.formDatas.territory_id, customer_id: this.formDatas.customer_data.customer_id, so_type:this.formDatas.so_types, is_default: true, is_create: (this.formDatas.isDetail != 1 && !this.formDatas.isEdit) };
          }
        }
        this.getDataShipTo({ params: params_ });
      }
    }, 1000),
    async setSelectedData(data) {
      this.selected = data;
    },
    async setContactName(contact_name) {
      if (contact_name&&this.selected!=null) {
        this.selected.contact_name = contact_name;
      }
    },
    async setAddress(address) {
      if (address&&this.selected!=null) {
        this.selected.address = address;
      }
    },
    async toggleDisabled() {
      this.isDisabledV2= !this.isDisabledV2;
      // this.isDisabled = !this.isDisabled;
    },
    async getDataShipTo(params) {
      if (!params) {
        params = {}//biar nggak error "Cannot set properties of undefined"
      }
      params.so_type = params.so_type != undefined ? params.so_type : "sales_return";
      this.$vs.loading();
      console.log("params", params)
      try {
        const result = await MasterRepository.getCustomerAddressShipToSr(params);
        let resp = result;
        console.log("result", result);
        console.log("resp", resp);
        if (result.code == 200) {
          if (result.data.records != null) {
            
            if( result.data.records[0].cust_category == undefined ){
              if (resp.data.records.length == 1 && params.params.is_default) {
                this.selected = resp.data.records[0];
                this.options = resp.data.records;
              } else {
                this.options = resp.data.records;
              }
            } else {
              if (resp.data.records.length == 1 && params.params.is_default) {
                this.selected = resp.data.records[0].cust_address;
              }
              this.options = [];
              this.result = result.data.records;
              result.data.records.forEach(el => {
                this.options.push( el.cust_address )
              });
            }
            console.log("this.formDatas", this.formDatas)
            if(this.formDatas.so_types == 'with_so_reference' || this.formDatas.isDetail == 1 || this.formDatas.isEdit ){
              this.setDisabled(true);
              // this.toggleDisabled();
            } else {
              this.setDisabled(false);
            }
  
            // if (this.formDatas.isDetail == 0 && this.formDatas.so_types != 'with_so_reference') {
            //   this.setDisabled(false);
            // }
          } else {
            console.log("Data is null | resp", resp);
            // this.$vs.notify({
            //   title: "Warning",
            //   text: "Customer address ship to not found.<br> Or please check your master data customer.<br> Allow return, etc.",
            //   color: "warning",
            //   iconPack: "feather",
            //   icon: "icon-alert-circle",
            // });    
            this.$vs.notify({
              title: "Warning",
              text: "Customer address ship to not found.<br> Or please check your master data customer.<br> Allow return, etc.",
              color: "warning",
              iconPack: "feather",
              icon: "icon-alert-circle",
            });    
          }
        } else {
          console.log("Error resp", resp);
          this.$vs.notify({
            title: "Error",
            text: resp.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-circle",
          });  
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching customer address ship to",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        console.log("Error while fetching customer address ship to", error);
      }
      this.$vs.loading.close();
    },
    async resetForm() {
      this.selected = null
    },
  },
  watch: {
    selected(v) {
      console.log("v", v)
      console.log("this.result", this.result);

      // CR-2600576, untuk prod belum ada penjagaan allow return
      // insiden ilmi merge branch enhance ke prod
      // cukup comment coding dibawah ini jika enhance CR-2600053 naik ke prod
      let override = true 
      this.selected = v;
      this.$emit("data", v); 
      if(override == true){
        return
      }

      if(this.formDatas.isDetail != 1 && !this.formDatas.isEdit ){
        let resSelected = this.result.filter((master) => {
          console.log("master", master);
          return master.cust_address.ID == v.ID;
        });
        console.log("resSelected", resSelected);
        if(resSelected.length > 0){
          // CR-2600053_Cek Config Allow Return
          let msg = ""
          if(resSelected[0].cust_category.allow_return != null && resSelected[0].cust_category.allow_return == false){
            // Dist Channel -> menentukan with & without ref. False, maka tidak boleh semua type retur.
            // CR-2600123 - Ubah wording saja.
            // Old msg = "Cannot using shipto for all return type!<br> Dist Channel "+resSelected[0].cust_category.name+" Allow Return False!",
            msg = "Customer "+ resSelected[0].cust_category.name +" not allowed return."
            this.$vs.notify({
              title: "Error",
              text: msg,
              color: "danger",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.selected = null;
            return;
          } else {
            // Cek Cg 1 2 3 | menetukan without ref saat Dist Channel masih true.
            let cg1 = null, cg2 = null, cg3 = null
            cg1 = resSelected[0].cust_group_1.sr_without_ref;
            cg2 = resSelected[0].cust_group_2.sr_without_ref;
            cg3 = resSelected[0].cust_group_3.sr_without_ref;

            // Misal cg3 = false;
  
            console.log("resSelected[0].cust_category.allow_return", resSelected[0].cust_category.allow_return)
            console.log("cg1, 2, 3", cg1, cg2, cg3)
            if(cg1 && cg2 && cg3) {
              // Allow All Type Retur, cc, cg1 2 3 True semua
              console.log("Allow return all true cg1, 2, 3", cg1, cg2, cg3)
              this.selected = v;
              this.$emit("data", v);
            } else {
              msg = "Allow Return False for"
              if(this.formDatas.so_types != 'with_so_reference' && this.formDatas.isDetail != 1 && !this.formDatas.isEdit ){
                if(cg1 || cg2 || cg3){
                  // Kalau false salah satu, hanya boleh return with ref
                  // CR-2600123 - Ubah wording saja.
                  msg = "Customer group "
                  
                  this.selected = null;
                  if(!cg1 && cg1 != null){
                    // msg += "<br>Customer Group 1 " + resSelected[0].cust_group_1.code
                    msg += resSelected[0].cust_group_1.code + " "
                  }
                  if(!cg2 && cg2 != null){
                    // msg += "<br>Customer Group 2 " + resSelected[0].cust_group_2.code
                    msg += resSelected[0].cust_group_2.code + " "
                  }
                  if(!cg3 && cg3 != null){
                    // msg += "<br>Customer Group 3 " + resSelected[0].cust_group_3.code
                    msg += resSelected[0].cust_group_3.code + " "
                  }
                  
                  msg += "not allowed return without reference."

                  // Old msg
                  // msg = "Cannot using shipto for return without reff !<br>" + msg
                  
                  this.$vs.notify({
                    title: "Error",
                    text: msg,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                  });
                  return;
                } else {
                  this.selected = v;
                  this.$emit("data", v);
                }
              } else {
                // Kalau cc masih true, cg 1 2 3 false semua dan SR Type with reff, maka boleh dipakai.
                console.log("Allow return cc", resSelected[0].cust_category.allow_return)
                console.log("Allow return all false cg1, 2, 3", cg1, cg2, cg3)
                console.log("Cg Allow return all false but CC true and with_so_reference", cg1, cg2, cg3)
                if(this.formDatas.so_types == 'with_so_reference'){
                  this.selected = v;
                  this.$emit("data", v);
                }
              }
            }
          }
        }
      } else {
        this.selected = v;
        this.$emit("data", v);
      }
      // this.selected = v;
      // this.$emit("data", v);
    },
  },
};
</script>
